import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const location = useLocation();               // aktueller Seitenpfad
  const isGlossar = location.pathname === '/glossar'; // prüft ob Glossar aktiv ist

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        document.body.classList.add('scrolled');
      } else {
        document.body.classList.remove('scrolled');
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup bei Komponenten-Unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navbar ${isGlossar ? 'navbar-glossar' : ''}`}>
      {/* Linke Seite – Glossar-Button */}
      <div className="nav-left">
        <Link to="/glossar" className="glossar-btn">Glossar</Link>
      </div>

      {/* Mitte – Logo */}
      <div className="nav-center">
        <Link to="/" className="logo">
          <img src={process.env.PUBLIC_URL + '/img/mulio-logo.svg'} alt="mulio Logo" />
        </Link>
      </div>

      {/* Rechte Seite – Profil */}
      <div className="nav-right">
        <div className="profile-small">
          <img src={process.env.PUBLIC_URL + '/img/profilbild.png'} alt="Profilbild des Nutzers" />
          <span>Max Mustermann</span>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;